<!-- Playlist page: same look as My Library and the new video pages (network colours through --vd-* variables).
     Play, pause, remove and report use the existing handlers. -->
<div class="app-playlist-details pl-page" [ngStyle]="themeVars">
  <button type="button" class="pl-back" (click)="goToPlaylist()"><app-vd-icon name="back"></app-vd-icon> Back</button>

  <section class="pl-hero" *ngIf="playListFirst?.id">
    <ng-container *ngIf="cover(playListFirst) as images">
      <div class="pl-hero-bg" aria-hidden="true" [style.background-image]="images.length ? 'url(' + images[0] + ')' : null"></div>
      <div class="pl-cover-wrap">
        <div class="pl-cover">
          <span class="pl-mosaic" *ngIf="images.length == 4"><img *ngFor="let src of images" [src]="src" alt=""></span>
          <img *ngIf="images.length == 1" [src]="images[0]" alt="">
          <span class="pl-art" *ngIf="!images.length" aria-hidden="true">{{ initial(playListFirst?.playlist_name) }}</span>
        </div>
      </div>
    </ng-container>
    <div class="pl-info">
      <div class="pl-eyebrow">{{ playlist_type == 'audio' ? 'Audio playlist' : 'Video playlist' }}</div>
      <h1 class="pl-title">{{ playListFirst?.playlist_name }}</h1>
      <div class="pl-meta">
        <span class="pl-meta-chip"><app-vd-icon [name]="playlist_type == 'audio' ? 'polls' : 'play'"></app-vd-icon>
          {{ countLabel({ stream_ids: playListFirst?.stream_files, playlist_type: playlist_type }) || (playlist_type == 'audio' ? 'No songs yet' : 'No videos yet') }}</span>
      </div>
      <button type="button" class="pl-play-all" *ngIf="songsCount > 0" [disabled]="playlist_type == 'audio' && enablePlay"
        (click)="playFromBanner(template)"><app-vd-icon name="play"></app-vd-icon> Play all</button>
    </div>
  </section>

  <div class="pl-list" *ngIf="playListFirst?.stream_files?.length">
    <div class="pl-row" *ngFor="let file of playListFirst.stream_files; let i = index" [class.is-playing]="file.isAudioPlaying">
      <span class="pl-index" aria-hidden="true">{{ i + 1 }}</span>
      <button type="button" class="pl-thumb" [attr.aria-label]="'Play ' + (file?.stream_info?.stage || '')"
        (click)="playlist_type == 'audio' ? toggleAudio(file, i, file.isAudioPlaying ? 'pause' : null) : openModalWithClass(template, file.stream_info)">
        <app-vd-thumb [info]="file?.stream_info" [fallback]="playlist_type == 'audio' ? assets_url + 'album-cover.svg' : video_banner_image"></app-vd-thumb>
        <span class="pl-thumb-play" aria-hidden="true"><app-vd-icon [name]="file.isAudioPlaying ? 'pause' : 'play'"></app-vd-icon></span>
        <span class="pl-duration" *ngIf="file?.stream_info?.duration && !('' + file.stream_info.duration).includes('NaN')">{{ file.stream_info.duration }}</span>
      </button>
      <div class="pl-body">
        <div class="pl-name">{{ file?.stream_info?.stage }}</div>
        <div class="pl-row-meta">
          <span class="pl-badge" *ngIf="file?.stream_info?.ageInfo">{{ file.stream_info.ageInfo }}</span>
        </div>
      </div>
      <div class="pl-actions">
        <button type="button" class="pl-play" [attr.aria-label]="file.isAudioPlaying ? 'Pause' : 'Play'"
          (click)="playlist_type == 'audio' ? toggleAudio(file, i, file.isAudioPlaying ? 'pause' : null) : openModalWithClass(template, file.stream_info)">
          <app-vd-icon [name]="file.isAudioPlaying ? 'pause' : 'play'"></app-vd-icon>
        </button>
        <div class="dropdown d-inline-block">
          <button type="button" class="pl-icon-btn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" aria-label="More">
            <app-vd-icon name="more"></app-vd-icon>
          </button>
          <div class="dropdown-menu dropdown-menu-right pl-menu">
            <button type="button" class="dropdown-item" (click)="removeFromPlaylist(file)"><app-vd-icon name="delete"></app-vd-icon> Remove from playlist</button>
            <button type="button" class="dropdown-item" [disabled]="router.url.includes('/preview')"
              (click)="reportFileData(file, playlist_type == 'audio' ? 'audio' : 'uploadedVideo')"><app-vd-icon name="report"></app-vd-icon> Report</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="pl-empty" *ngIf="playListFirst?.id && !playListFirst?.stream_files?.length">
    <span class="pl-empty-icon"><app-vd-icon name="playlist"></app-vd-icon></span>
    <p class="pl-empty-title">This playlist is empty</p>
    <p class="pl-empty-text">Use "Add to playlist" on any {{ playlist_type == 'audio' ? 'song' : 'video' }} to add it here.</p>
  </div>
</div>

<ng-template #template>
  <div class="modal-body">
    <div class="album-video-title-box">
      <div class="album-video-title"> {{selectedVideo?.stage}} </div>
      <div class="report-btn album-video-title" (click)="reportFileData(selectedVideo, 'playerVideo')" matTooltipPosition="below" matTooltip="Report Abuse">
        <i class="fa fa-flag"></i>
      </div>
      <div class="close-btn album-video-title" (click)="close()">
        <app-svg [icon]="'close-icon-white'"></app-svg>
      </div>
    </div>
    <m3u8-video id="uploadedVideoPlayer" (timeupdate)="getCurrentTime($event)" [videoUrl]="videoURL"
      [openFrom]="'VideoAlbum'" autoplay></m3u8-video>
  </div>
</ng-template>
